import React from 'react';
export function Footer() {
  return <footer className="bg-deco-text text-deco-card py-10 px-4 text-center" data-id="element-49">
      <div className="max-w-7xl mx-auto flex flex-col items-center gap-4" data-id="element-50">
        <img src="https://cdn.magicpatterns.com/uploads/59hFAgyxREzsQ1LsETU8H2/LOGO_DECO_EMPRENDE-removebg-preview.png" alt="Deco Emprende" className="h-16 object-contain opacity-80 brightness-0 invert" data-id="element-51" />
        <h3 className="font-serif text-xl sm:text-2xl text-deco-warm tracking-wide" data-id="element-52">
          Cemento & Yeso Deco
        </h3>
        <div className="w-12 h-px bg-deco-card/20 my-2" data-id="element-53" />
        <p className="text-deco-card/50 text-xs sm:text-sm" data-id="element-54">
          © {new Date().getFullYear()} Deco Emprende. Todos los derechos
          reservados.
        </p>
      </div>
    </footer>;
}